import { useEffect, useRef, useState } from 'react';
import useDebouncedValue from './useDebouncedValue';
import { searchCommandBar } from '@/redux/actions/userActions';
import { useSelector } from 'react-redux';
import selectors from '@/redux/selectors/selectors';
import { action } from '@/lib/api';
import { store } from '@/redux/lib/configureStore.js';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';

const SEARCH_DEBOUNCE_DELAY = 350;

const useCommandBar = () => {
  const [showCommandBar, setShowCommandBar] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const debouncedSearch = useDebouncedValue(searchQuery, SEARCH_DEBOUNCE_DELAY);
  const cancelRef = useRef();

  const commandBar = useSelector((state) => state.user.commandBar);
  let isLoading = useArgSelector(selectors.isLoading, 'searchCommandBar');

  isLoading = !searchQuery ? false : isLoading;

  useEffect(() => {
    if (debouncedSearch) {
      searchCommandBar({ q: debouncedSearch, cancelRef });
    }
  }, [debouncedSearch, cancelRef]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setShowCommandBar((prev) => !prev);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  useEffect(() => {
    if (!showCommandBar) {
      setSearchQuery('');
      action('CLEAR_COMMAND_BAR');
    }
    if (searchQuery === '') {
      action('CLEAR_COMMAND_BAR');
    }
  }, [showCommandBar, searchQuery, isLoading]);

  const onOpenChange = (open) => {
    setShowCommandBar(open);
  };

  const handleSearchQueryChange = (e) => {
    store.dispatch({ type: 'setLoader', payload: { key: 'searchCommandBar', isLoading: true, loadStart: new Date() } });
    setSearchQuery(e.target.value);
  };

  return { searchQuery, handleSearchQueryChange, data: commandBar, open: showCommandBar, onOpenChange, isLoading };
};

export default useCommandBar;
